<template>
  <div class="bg-[#7B614C] h-full">
    <div class="flex flex-col h-full antialiased text-white error-bg">
      <div class="flex flex-col justify-center flex-grow max-w-xl mx-auto">
        <div class="lg:-ml-96">
          <div v-if="error.statusCode === 404">
            <p class="font-thin text-7xl">404</p>
            <p class="font-medium">{{ $t("error.title_404") }}</p>
            <p>{{ $t("error.subtitle_404") }}</p>
          </div>
          <p class="text-xl" v-else>
            <span class="text-h1">Error {{ error.statusCode }}</span
            ><br />{{ error.statusMessage || error.message }}
          </p>
          <NuxtLink
            tag="button"
            :to="localePath('/')"
            class="mt-4 btn-fg btn-fg-white btn-md inline-flex items-center"
          >
            {{ $t("error.back_button_label") }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
//import { useI18n } from "vue-i18n";
//import { useRoute, useRouter } from "vue-router";
//import { computed } from "vue";

import type { NuxtError } from "#app";
const localePath = useLocalePath();

const props = defineProps({
  error: Object as () => NuxtError,
});

//const route = useRoute();

//const route = useRoute();
//const router = useRouter();
//const { t } = useI18n();

//const error = computed(() => route.params.error || { statusCode: 500, message: "Unknown error" });

/*
const localePath = (path) => {
  // Assuming you have a function to get the localized path
  return path;
};
*/

useHead({
  htmlAttrs: {
    class: "h-full",
  },
  bodyAttrs: {
    class: "h-full",
  },
});
</script>

<style>
#__layout,
#__nuxt {
  @apply h-full;
}
.error-bg {
  background: url("~/assets/images/404_multiply.png");
  background-blend-mode: multiply;
  @apply bg-contain bg-center bg-no-repeat bg-[#7B614C];
}
</style>
